import http from '@/vendor/axios'

export function login () {
  const url = '/object/res.users/current_user'
  return http.post(url, {})
}

export function editKeyResultAuth (keyResultId, userIds, op_src = 1) {
  // const url = `/object/okr.keyresult/${keyResultId}/apply_rule`
  const url = `/object/okr.keyresult/${keyResultId}/apply_rule_ex`
  return http.post(url, {
    params: {
      kwargs: {
        user_ids: userIds,
        op_src
      }
    }
  })
}

export function removeKeyResultAuth (keyResultId, userIds, op_src = 1) {
  const url = `/object/okr.keyresult/${keyResultId}/remove_rule_ex`
  return http.post(url, {
    params: {
      kwargs: {
        user_ids: userIds,
        op_src // 1: @   2：对齐
      }
    }
  })
}

export function editObjectiveAuth (id, userIds, op_src = 1) {
  const url = `/object/okr.objective/${id}/apply_rule_ex`
  return http.post(url, {
    params: {
      kwargs: {
        user_ids: userIds,
        op_src
      }
    }
  })
}

export function removeObjectiveAuth (id, userIds, op_src = 1) {
  const url = `/object/okr.objective/${id}/remove_rule_ex`
  return http.post(url, {
    params: {
      kwargs: {
        user_ids: userIds,
        op_src
      }
    }
  })
}
